<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div class="fixed inset-0 overflow-hidden z-30" v-show="isVisible">
      <div class="absolute inset-0 overflow-hidden">
        <transition
          enter-active-class="ease-in-out duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in-out duration-200"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div v-show="isVisible" class="fixed inset-0 transition-opacity backdrop-blur backdrop-filter" @click="isVisible = false">
            <div class="absolute inset-0 bg-gray-700 opacity-50"></div>
          </div>
        </transition>
        <section class="absolute inset-y-0 right-0 max-w-full flex">
          <transition
            enter-active-class="transform transition ease-in-out duration-200 sm:duration-300"
            enter-from-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transform transition ease-in-out duration-100 sm:duration-200"
            leave-from-class="translate-x-0"
            leave-to-class="translate-x-full"
          >
            <div :class="`w-screen max-w-${size}`" v-show="isVisible">
              <div class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">
                <div class="h-0 flex-1 flex flex-col overflow-y-auto" ref="scrollableSection" style="scroll-behavior: smooth">
                  <header class="px-4 sm:px-6 sticky top-0 bg-white border-b border-gray-150 py-4 sm:py-6 z-50">
                    <div class="flex items-start justify-between space-x-3">
                      <slot name="title">
                        <h2 class="text-lg leading-7 font-normal text-gray-800 mb-0">{{ title }}</h2>
                      </slot>
                      <div class="h-7 flex items-center">
                        <base-icon @click="isVisible = false">
                          <x-icon class="h-6 w-6" />
                        </base-icon>
                      </div>
                    </div>
                  </header>
                  <div class="relative flex-1">
                    <slot />
                  </div>
                </div>
                <slot name="fixed-bottom"></slot>
              </div>
            </div>
          </transition>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import { XIcon } from "@/assets/svgs";

export default {
  inheritAttrs: false,
  emits: ["showing", "hiding"],
  components: {
    XIcon,
  },
  props: {
    title: String,
    size: {
      type: String,
      default: "md",
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    },
    scrollContentToBottom() {
      this.$refs.scrollableSection.scrollTop = this.$refs.scrollableSection.scrollHeight;
    },
  },
  watch: {
    isVisible(newVal) {
      this.$emit(newVal ? "showing" : "hiding");
    },
  },
};
</script>
